import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper'

export const SessionTypeStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: []
};

const SessionTypeContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <SessionTypeStateContext.Provider value={stateHook}>
      {children}
    </SessionTypeStateContext.Provider>
  );
};

export default SessionTypeContextProvider;